import { Product } from "./components/product/product";
import { Base } from "./productList.base";

export const ProductList = Object.assign(Base, {
    Product
});
